import { gql } from 'graphql-request'

export const GET_SURVEYS = gql`
  query getSurveysMethods {
    surveys(where: { visible: { _eq: true } }) {
      id
      title
      description
      creator_id
      banner_desktop_url
      banner_mobile_url
      visible
      total_votes
      product1_votes
      product2_votes
      product1_category
      product2_category
      product1_title
      product2_title
      product1_description
      product2_description
      product1_photos_url
      product2_photos_url
      created_at
      updated_at
      creator {
        nickname
      }
    }
  }
`

export const GET_CREATOR_SURVEYS = gql`
  query getCreatorSurveys($creator_id: Int) {
    surveys(
      where: { creator_id: { _eq: $creator_id }, visible: { _eq: true } }
    ) {
      id
      creator_id
      banner_desktop_url
      banner_mobile_url
      visible
      creator {
        nickname
      }
    }
  }
`
